import { Link as MUILink, LinkProps as MUILinkProps } from "@mui/material";

import { useAnalytics } from "@/providers";
import {
  ComponentPropsWithEvent,
  EventName,
} from "@/shared/services/analytics";

type RobotoLinkButtonProps<T extends EventName> = ComponentPropsWithEvent<
  T,
  MUILinkProps
>;

export function RobotoLinkButton(
  props: Partial<RobotoLinkButtonProps<EventName>>,
) {
  const { trackEvent } = useAnalytics();
  const { eventName, eventProperties, onClick, children, ...filteredProps } =
    props;

  return (
    <MUILink
      {...filteredProps}
      onClick={(e) => {
        if (eventName) {
          trackEvent(eventName, eventProperties);
        }
        onClick?.(e);
      }}
    >
      {children}
    </MUILink>
  );
}
